import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import Tax from '../../../../components/modules/master/tax';
import TaxMiddleware from '../../../../middleware/modules/master/tax';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';
import Coa3Middleware from '../../../../middleware/modules/accounting/coa3';
// middlewares


const mapStateToProps = ({ auth,tax }) => ({
  isProcessing: tax.isProcessing,
  isError: tax.isError,
  errorMessage: tax.errorMessage,
  datalist:tax.data,
  showModal:tax.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>TaxMiddleware.create(),
    getUnit: () =>TaxMiddleware.getHelper(),
    getCoa: () =>Coa3Middleware.getHelper(),
    reset: () =>TaxMiddleware.resetList(),
    search: data =>TaxMiddleware.list(data),
    update: data =>TaxMiddleware.update(data),
    delete: (id,search) =>TaxMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class TaxContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
   this.props.search(search);
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    this.props.getCoa();
    this.props.update(id)
  }
  createItem(){
    this.props.getCoa();
    this.props.create()
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Tax List")}
          </title>
        </Helmet>
      <Tax
        {...this.props}
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxContainer);
